const isEditorPlugin = (pluginOrConfig) => {
  return "tiptapExtensions" in pluginOrConfig;
};
const isEditorPluginOptions = (pluginOrConfig) => {
  return !("tiptapExtensions" in pluginOrConfig);
};
const isCommonPluginOptions = (pluginOrConfig) => {
  return !("tiptapExtensions" in pluginOrConfig) && ["LAYOUT", "layout", "fontSize"].includes(pluginOrConfig.type);
};
export {
  isCommonPluginOptions,
  isEditorPlugin,
  isEditorPluginOptions
};
//# sourceMappingURL=is-editor-plugin.js.map
